import { createCall, spellbook } from "@sdk/spellbook";

const endpoint = spellbook("/legal-values").GET();

export type GetLegalValuesResponse = typeof endpoint.types.Res;

export async function getLegalValues() {
    const call = createCall(endpoint, (r) => fetch(r));

    return await call({});
}
